<script setup lang="ts">
import { ZuordnungImportHeader } from '@/models/ZuordnungImportHeader';
import Select, { type SelectChangeEvent } from 'primevue/select';
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        options?: any[];
        headerModel: ZuordnungImportHeader;
    }>(),
    { options: () => [], header: new ZuordnungImportHeader() },
);

const emit = defineEmits<{
    (e: 'change', option: SelectChangeEvent): void;
}>();

const modelValue = computed(() => {
    const m = props.options.find((h) => h.variable === props.headerModel.header)?.id;
    emit('change', { value: m, originalEvent: new Event('select') });
    return m;
});
</script>

<template>
    <Select
        filter
        :model-value="modelValue"
        :options="options"
        option-value="id"
        option-label="bezeichnung_de"
        :placeholder="$t('bitte_waehlen')"
        class="field col-12 md:col-5"
        @change="(value) => $emit('change', value)"
    >
    </Select>
</template>
